import React from 'react';
import { css } from 'styled-components';
import { applyStyles } from 'util/helpers';

const Layer = ({ className, children }) => (
  <div className={className}>
    <div className="mask" />
    {children}
  </div>
);

const commonStyle = css`
  position: relative;
  pointer-events: none;

  .mask {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    z-index: 1;
  }
`;

export default applyStyles(Layer)(commonStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/Layer.js